import { Stack } from 'braid-design-system';

import Error from 'src/components/Error/Error';
import JobCard from 'src/components/JobCard/JobCard';
import type { RecommendedGlobalJob } from 'src/queries/types';

const JobList = ({
  globalJobs,
  hasError,
  jobCount,
  hasAuthError,
  setCurrentJob,
  selectedJobId,
}: {
  globalJobs: RecommendedGlobalJob[];
  hasError: boolean;
  hasAuthError: boolean;
  jobCount?: number;
  setCurrentJob?: (job: RecommendedGlobalJob) => void;
  selectedJobId?: string;
}) => {
  if (hasAuthError) {
    return null;
  }

  if (hasError) {
    return <Error data-automation="loading-recs-error-alert" />;
  }

  if (jobCount === 0) {
    return <></>;
  }

  return (
    <Stack space="small">
      {globalJobs.map((job, index) => (
        <JobCard
          key={job.job.id}
          job={job}
          setCurrentJob={setCurrentJob}
          selectedJobId={selectedJobId}
          listPosition={index + 1}
        />
      ))}
    </Stack>
  );
};

export default JobList;
